import { createContext } from 'react';

export const ServiceItemsContext = createContext({
  connectToWebSocket: () => {},
});
